import styled from 'styled-components';
import { YAxisTitle } from '../BarStacked/BarStacked.styles';

export const XAxisTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 102px;
  padding-left: 15px;
  padding-top: 20px;
`;

export const StyledYAxisTitle = styled(YAxisTitle)`
  margin-right: 20px;
`;

export const LineChartAndAxisContainer = styled.div`
  width: 100%;
`;

export const LineChartSvgContainer = styled.div<{ width: string }>`
  width: ${(props) => props.width};
`;

export const ScrollableDiv = styled.div<{
  width: string;
  height: string;
  marginTop: string;
  marginLeft: string;
  hasScroll: boolean;
}>`
  overflow-x: ${(props) => (props.hasScroll ? 'auto' : 'hidden')};
  overflow-y: hidden;
  ${(props) =>
    props.hasScroll
      ? `
    mask-image: linear-gradient(to left, ${props.theme.atlas.semantic.color.surface.default}00 0px, ${props.theme.atlas.semantic.color.surface.default} 50px);
    padding-right: 10px;
    border-bottom: 1px solid ${props.theme.atlas.semantic.color.surface.default};`
      : ''}
  ${(props) => `width: ${props.width};
                height: ${props.height};
                margin-top: ${props.marginTop};
                margin-left: ${props.marginLeft};`}
`;
